'use client'

import dynamic from 'next/dynamic'
import { dir } from 'i18next'
import { Grid, Typography, Box } from '@mui/material'
import { East as EastIcon, West as WestIcon } from '@mui/icons-material'

// Types
import type { SectionHeaderProps } from '@/types/components/molecules/section-header'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Components
const WhiteButtonAtom = dynamic(() => import('@/components/atoms/buttons/text/white'))

const SectionHeaderMolecule = (props: SectionHeaderProps) => {
	// Props
	const { lng, title, subtitle } = props

	// Varaibles
	const lngDir = dir(lng)
	const { t } = useTranslation(lng)

	return (
		<Grid container justifyContent="space-between" alignItems="center">
			<Grid size="auto">
				<Typography component="h3" display="flex" flexDirection="column" fontSize={{ xs: 24, md: 50 }} fontWeight={700} lineHeight={1}>
					<Box component="span" color="primary.main">
						{t(title)}
					</Box>

					<Box component="span" color="common.white">
						{t(subtitle)}
					</Box>
				</Typography>
			</Grid>

			<Grid size="auto">
				<WhiteButtonAtom title={t('common:title.seeMore')} endIcon={lngDir === 'rtl' ? <WestIcon /> : <EastIcon />} />
			</Grid>
		</Grid>
	)
}

export default SectionHeaderMolecule
